var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardSettingAlertsettingManagesymbolfilesPopupSuccessIcon = function SvgNewcsDashboardSettingAlertsettingManagesymbolfilesPopupSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 48
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_setting_alertsetting_managesymbolfiles_popup_success_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M568 317h64v48h-64z",
    "data-name": "\\u77E9\\u5F62 587"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_setting_alertsetting_managesymbolfiles_popup_success_icon_svg__a)",
    transform: "translate(-568 -317)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#38b16a",
    d: "M591.303 344.736a18.468 18.468 0 0 0 36.936 0 18.468 18.468 0 0 0-36.936 0",
    "data-name": "\\u8DEF\\u5F84 514",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "M618.8 361.525h-6.51a2.015 2.015 0 1 1 0-4.029h6.51a9.167 9.167 0 0 0 0-18.334h-.336a2.014 2.014 0 0 1-2.015-1.981 16.44 16.44 0 0 0-32.873-.034 2.014 2.014 0 0 1-2.015 1.981h-.331a9.184 9.184 0 1 0 0 18.367h5.943a2.015 2.015 0 1 1 0 4.029h-5.943a13.209 13.209 0 0 1-1.578-26.324 20.478 20.478 0 0 1 40.7 0 13.209 13.209 0 0 1-1.552 26.325",
    "data-name": "\\u8DEF\\u5F84 515"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "M599.384 365.005a2.17 2.17 0 0 1-1.433-.567l-7.965-8.032a2.03 2.03 0 0 1 0-2.833 1.99 1.99 0 0 1 2.8 0l6.565 6.6 12.531-12.6a1.99 1.99 0 0 1 2.8 0 2.03 2.03 0 0 1 0 2.833l-13.964 14.03a1.71 1.71 0 0 1-1.334.569",
    "data-name": "\\u8DEF\\u5F84 516"
  }))));
};
export default SvgNewcsDashboardSettingAlertsettingManagesymbolfilesPopupSuccessIcon;